export var EventTimeSource;
(function (EventTimeSource) {
    EventTimeSource[EventTimeSource["CUSTOM_HOURS"] = 1] = "CUSTOM_HOURS";
    EventTimeSource[EventTimeSource["ACCOUNT_BUSINESS_HOURS"] = 2] = "ACCOUNT_BUSINESS_HOURS";
})(EventTimeSource || (EventTimeSource = {}));
//# sourceMappingURL=rule-conditions.i.js.map